import { useNavigate } from 'react-router-dom';

import { Routes } from '@/constants';
import { EVENT_CONSTANTS } from '@/services';
import { EpisodeCard } from '@/types';

import { EpisodeCardVariants } from '../EpisodeCard';
import { EpisodeCardCarousel } from '../EpisodeCardCarousel';

interface SpecialFeaturesCarouselProps {
  episodes: EpisodeCard[];
  isLoading?: boolean;
}

export const SpecialFeaturesCarousel = ({
  episodes,
  isLoading,
}: SpecialFeaturesCarouselProps) => {
  const navigate = useNavigate();
  const specialFeaturesSearchRoute = {
    pathname: Routes.SEARCH,
    search: new URLSearchParams({ searchTerm: 'Special Features' }).toString(),
  };

  return (
    <EpisodeCardCarousel
      variant={EpisodeCardVariants.LARGE}
      descriptionCardProps={{
        title: 'Special Features',
        hook: 'These episodes are scripted, informative and easy to binge-listen. Think true-crime story telling and business case studies.',
        onClick: () => navigate(specialFeaturesSearchRoute),
      }}
      uKey="Special Features Episodes"
      episodes={episodes}
      isLoading={isLoading}
      referrer={{
        page: EVENT_CONSTANTS.PAGE.DISCOVER,
      }}
      sortCompletedEpisodesLast={true}
    />
  );
};
